export const ADD_ORDER_RETURN_CHECK = Symbol('ADD_ORDER_RETURN_CHECK');
export const ADD_ORDER_RETURN_CHECK_REQUEST = Symbol('ADD_ORDER_RETURN_CHECK_REQUEST');
export const ADD_ORDER_RETURN_CHECK_SUCCESS = Symbol('ADD_ORDER_RETURN_CHECK_SUCCESS');
export const ADD_ORDER_RETURN_CHECK_ERROR = Symbol('ADD_ORDER_RETURN_CHECK_ERROR');
export const DELETE_ORDER_RETURN_CHECK = Symbol('DELETE_ORDER_RETURN_CHECK');
export const DELETE_ORDER_RETURN_CHECK_REQUEST = Symbol('DELETE_ORDER_RETURN_CHECK_REQUEST');
export const DELETE_ORDER_RETURN_CHECK_SUCCESS = Symbol('DELETE_ORDER_RETURN_CHECK_SUCCESS');
export const DELETE_ORDER_RETURN_CHECK_ERROR = Symbol('DELETE_ORDER_RETURN_CHECK_ERROR');
